export default {
  // Page title
  'pages.accountB.config.title': 'B Account Configuration',

  // Buttons
  'pages.accountB.config.addDevice': 'Add Device',
  'pages.accountB.config.editDevice': 'Edit Device',
  'pages.accountB.config.query': 'Query',
  'pages.accountB.config.reset': 'Reset',
  'pages.accountB.config.save': 'Save',
  'pages.accountB.config.cancel': 'Cancel',
  'pages.accountB.config.confirm': 'Confirm',
  'pages.accountB.config.back': 'Return',
  'pages.accountB.config.saveConfig': 'Save Configuration',
  'pages.accountB.config.batchModify': 'Batch Modify',

  // Search
  'pages.accountB.config.search.tenant': 'Tenant',
  'pages.accountB.config.search.tenant.placeholder': 'Please select tenant',
  'pages.accountB.config.search.store': 'Store',
  'pages.accountB.config.search.store.placeholder': 'Please select store',
  'pages.accountB.config.search.device': 'Device',
  'pages.accountB.config.search.device.placeholder': 'Please select device',

  // List columns
  'pages.accountB.config.column.tenantId': 'Tenant ID',
  'pages.accountB.config.column.tenantName': 'Tenant Name',
  'pages.accountB.config.column.storeName': 'Store Name',
  'pages.accountB.config.column.industryType': 'Industry Type',
  'pages.accountB.config.column.deviceName': 'Device Name',
  'pages.accountB.config.column.terminalNo': 'Terminal No.',
  'pages.accountB.config.column.discountRate': 'Discount Rate',
  'pages.accountB.config.column.executionStrategy': 'Execution Strategy',
  'pages.accountB.config.column.action': 'Action',
  'pages.accountB.config.action.edit': 'Edit',
  'pages.accountB.config.action.delete': 'Delete',
  'pages.accountB.config.action.detail': 'Detail',
  'pages.accountB.config.action.generate': 'Generate B',
  'pages.accountB.config.generate.modalTitle': 'Generate B-Account Data',
  'pages.accountB.config.generate.dateRange': 'Date Range',
  'pages.accountB.config.generate.confirm': 'Generate',
  'pages.accountB.config.generate.success':
    'Generated successfully, {n} records processed',
  'pages.accountB.config.generate.fail': 'Generation failed',
  'pages.accountB.config.generate.needDateRange': 'Please select a date range',
  'pages.accountB.config.generate.force':
    'Force regenerate with the latest rules (overwrites existing data in range)',
  'pages.accountB.config.generate.force.tip':
    'When checked, existing B-account data in the selected range is deleted first, then re-replicated and adjusted per current config. Unchecked + existing data → request is rejected.',
  'pages.accountB.config.generate.inProgress.title':
    'Generating B-Account Data',
  'pages.accountB.config.generate.inProgress.tip':
    'Replicating orders/payments/shifts/audit logs and applying B-account strategy. Estimated 5~10 seconds. Please do not close this window.',
  'pages.accountB.config.generate.inProgress.largeRange':
    'May take 30+ seconds for large date ranges or high data volume.',

  // Delete confirmation
  'pages.accountB.config.deleteConfirm':
    'Are you sure to delete this configuration?',

  // Edit modal
  'pages.accountB.config.modal.editTitle': 'Sales Price Strategy',
  'pages.accountB.config.form.tenantName': 'Tenant Name',
  'pages.accountB.config.form.storeName': 'Store Name',
  'pages.accountB.config.form.deviceName': 'Device Name',
  'pages.accountB.config.form.terminalNo': 'Terminal No.',
  'pages.accountB.config.form.terminalNo.placeholder': 'Auto export',
  'pages.accountB.config.form.dateRange': 'Date',
  'pages.accountB.config.form.selectPlaceholder': 'Please select',

  // Discount & Exclusion
  'pages.accountB.config.section.discount': 'Discount & Exclusion',
  'pages.accountB.config.discountRate': 'Discount Rate',
  'pages.accountB.config.discountRate.placeholder': 'Enter discount rate',
  'pages.accountB.config.excludedPaymentMethods': 'Excluded Payment Methods',
  'pages.accountB.config.excludeGovernmentDiscount':
    'Government Discount Order Mode',
  'pages.accountB.config.excludeGovernmentDiscount.desc':
    'Choose how government discount orders (SC/PWD/NAAC/SP/MOV/Diplomatic) are handled in the B-account reduction.',
  'pages.accountB.config.excludeGovernmentDiscount.mode.flatten':
    'Flatten & include in reduction',
  'pages.accountB.config.excludeGovernmentDiscount.mode.flatten.desc':
    'Government discount orders are adjusted by the reduction rate',
  'pages.accountB.config.excludeGovernmentDiscount.mode.keep':
    'Keep original, exclude from reduction',
  'pages.accountB.config.excludeGovernmentDiscount.mode.keep.desc':
    'Government discount orders keep their original value and are not adjusted',
  'pages.accountB.config.returnInvalidOrder': 'Return/Void Order',
  'pages.accountB.config.returnInvalidOrder.desc':
    'When enabled, return/void orders will not be included in the price reduction',
  'pages.accountB.config.enabled': 'Enabled',
  'pages.accountB.config.disabled': 'Disabled',

  // Execution Strategy
  'pages.accountB.config.section.strategy': 'Execution Strategy',
  'pages.accountB.config.strategy.deleteLine': 'Deduct Item Line',
  'pages.accountB.config.strategy.deleteLine.desc':
    'Deduct some items from the order first to reduce the total sales amount. Applicable when: large number of items, need to significantly reduce total sales. (Not applicable for single item)',
  'pages.accountB.config.strategy.replaceLow': 'High-Price to Low-Price',
  'pages.accountB.config.strategy.replaceLow.desc':
    'Replace high-price items with low-price items in the order to adjust the amount structure. Applicable when: need to keep item count unchanged, only adjust amount structure.',
  'pages.accountB.config.strategy.info':
    'The current strategy will be used by the scheduled Job to correct sales orders, return orders, shift handover data, log files, and audit trail files.',

  // Cash Management
  'pages.accountB.config.section.cash': 'Cash Management',
  'pages.accountB.config.cashIn': 'Cash in',
  'pages.accountB.config.cashIn.placeholder': 'Enter Cash in',
  'pages.accountB.config.shortOverMin': 'Short/Over Minimum',
  'pages.accountB.config.shortOverMin.placeholder': 'Enter minimum value',
  'pages.accountB.config.shortOverMax': 'Short/Over Maximum',
  'pages.accountB.config.shortOverMax.placeholder': 'Enter maximum value',

  // Select all / Clear
  'pages.accountB.config.selectAll': 'Select All',
  'pages.accountB.config.clearAll': 'Clear',

  // Config date modal
  'pages.accountB.config.dateModal.title': 'Select Application Date',
  'pages.accountB.config.dateModal.month.placeholder': 'Please select month',
  'pages.accountB.config.dateColumn.date': 'Date',
  'pages.accountB.config.dateColumn.status': 'Status',
  'pages.accountB.config.dateColumn.strategy': 'Adjustment Strategy',
  'pages.accountB.config.dateColumn.adjustedOrderCount': 'Adjusted Order Count',
  'pages.accountB.config.dateColumn.originalAmount': 'Original Amount',
  'pages.accountB.config.dateColumn.currentAmount': 'Current Amount',
  'pages.accountB.config.dateColumn.discountRate': 'Reduction Ratio',
  'pages.accountB.config.dateColumn.action': 'Action',
  'pages.accountB.config.dateAction.modify': 'Modify Configuration',
  'pages.accountB.config.dateAction.modifyDisabledTip':
    'Historical months are locked after the 7th and cannot be modified',

  // Messages
  'pages.accountB.config.message.saveSuccess': 'Saved successfully',
  'pages.accountB.config.message.saveFailed': 'Save failed',
  'pages.accountB.config.message.deleteSuccess': 'Deleted successfully',
  'pages.accountB.config.message.deleteFailed': 'Delete failed',

  // Configuration level (list column)
  'pages.accountB.config.column.configLevel': 'Configuration Level',
  'pages.accountB.config.configLevel.machine': 'Machine Level',
  'pages.accountB.config.configLevel.store': 'Store Level',

  // Store device (form)
  'pages.accountB.config.form.posDevice': 'Store Device',
  'pages.accountB.config.form.posDevice.placeholder':
    'Please select a store device',
  'pages.accountB.config.form.posDevice.required':
    'Please select a store device',
  'pages.accountB.config.form.posDevice.selectStoreFirst':
    'Please select a store first',
  'pages.accountB.config.form.posDevice.noActivePos':
    'No active POS for this store',
  'pages.accountB.config.form.posDevice.bound': 'Bound',
  'pages.accountB.config.form.posDevice.storeLevelHint':
    'Leave empty = store-level config (shared by the whole store); select a device = machine-level config',

  // Access verification
  'pages.accountB.config.auth.title': 'B Account Access Verification',
  'pages.accountB.config.auth.desc':
    'Please enter the access password to continue.',
  'pages.accountB.config.auth.placeholder': 'Please enter password',
  'pages.accountB.config.auth.wrongPassword':
    'Incorrect password, please try again.',

  // ===== B-Account data reset (super admin only) =====
  'pages.accountB.dataReset.cardTitle': 'Reset Parameters',
  'pages.accountB.dataReset.tenant': 'Tenant',
  'pages.accountB.dataReset.store': 'Store',
  'pages.accountB.dataReset.pos': 'POS Device',
  'pages.accountB.dataReset.startMonth': 'Start Month',
  'pages.accountB.dataReset.endMonth': 'End Month',
  'pages.accountB.dataReset.password': 'Operation Password',
  'pages.accountB.dataReset.tenant.placeholder':
    'Select target tenant (required)',
  'pages.accountB.dataReset.tenant.placeholder.empty':
    'No B-account config; nothing to reset',
  'pages.accountB.dataReset.tenant.required': 'Please select a tenant',
  'pages.accountB.dataReset.store.placeholder':
    'Empty = all configured stores of the tenant',
  'pages.accountB.dataReset.pos.placeholder':
    'Empty = all configured POS of the store',
  'pages.accountB.dataReset.startMonth.required':
    'Please select the start month',
  'pages.accountB.dataReset.endMonth.required': 'Please select the end month',
  'pages.accountB.dataReset.endMonth.beforeStart':
    'End month cannot be earlier than the start month',
  'pages.accountB.dataReset.password.placeholder':
    'Contact the platform admin for the reset password',
  'pages.accountB.dataReset.password.required':
    'Please enter the operation password',
  'pages.accountB.dataReset.password.tooltip':
    'The reset password is maintained by platform admins, injected from server-side YAML config; no plaintext is kept in source.',
  'pages.accountB.dataReset.submit': 'Execute B-Account Data Reset',
  'pages.accountB.dataReset.submitTip':
    'A confirmation dialog will appear after clicking',
  'pages.accountB.dataReset.alert.title':
    'Danger: physically delete and regenerate B-account data',
  'pages.accountB.dataReset.alert.desc':
    'This tool initializes historical B-account data for legacy customers. It bypasses the next-month 8th lock rule, physically deletes all 12+4 B-account tables within the selected range, and regenerates them according to the current config. Irreversible — carefully confirm tenant, store, and month range. The dropdowns only list ranges that already have a B-account strategy configured.',
  'pages.accountB.dataReset.confirm.title':
    'Danger: confirm B-account data reset?',
  'pages.accountB.dataReset.confirm.body':
    'This will physically delete and regenerate B-account data for the selected range. Irreversible.',
  'pages.accountB.dataReset.confirm.tenant': 'Tenant',
  'pages.accountB.dataReset.confirm.store': 'Store',
  'pages.accountB.dataReset.confirm.pos': 'POS',
  'pages.accountB.dataReset.confirm.monthRange': 'Month Range',
  'pages.accountB.dataReset.confirm.ok': 'I confirm, execute reset',
  'pages.accountB.dataReset.confirm.cancel': 'Cancel',
  'pages.accountB.dataReset.allStores': 'All stores (configured range)',
  'pages.accountB.dataReset.allPos': 'All POS (configured range)',
  'pages.accountB.dataReset.tenantFallback': 'Tenant {id}',
  'pages.accountB.dataReset.storeFallback': 'Store {id}',
  'pages.accountB.dataReset.posFallback': 'POS {id}',
  'pages.accountB.dataReset.success':
    'Reset succeeded: {config} config(s) / {days} day(s) generated / {skipped} skipped / {ms}ms',
  'pages.accountB.dataReset.fail': 'Reset failed',
  'pages.accountB.dataReset.failWithMsg': 'Reset failed: {msg}',
};
